/**
 * 权限控制
 * 所有已登录管理员均可访问所有页面
 */
export default function access(
  initialState: { currentUser?: API.AdminUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin: !!currentUser,
  };
}
